import {v4 as uuid} from "uuid";

export class SingleTaskRunner<T> {
	private instances:{resolve:(result:T)=>void, reject:(error:any)=>void}[] = [];
	private task:()=>Promise<T>;
	private delay:number = 50;
	private currentInstanceId:string = "";


	public constructor(task:()=>Promise<T>, delay:number = 50){
		this.task = task;
		this.delay = delay;
	}

	public async run():Promise<T>{
		let instanceId = uuid();
		this.currentInstanceId = instanceId;
		return new Promise((resolve:(result:T)=>void, reject:(error:any)=>void)=>{
			setTimeout(async ()=>{
				try{
					this.instances.push({resolve, reject});
					if (this.currentInstanceId != instanceId) {
						return;
					}
					let result = await this.task();
					if (this.currentInstanceId != instanceId){
						return;
					}
					this.resolveAll(result);
				}catch(err){
					this.rejectAll(err);
				}
			}, this.delay);
		});
	}

	private resolveAll(value:T){
		for (let i = this.instances.length-1; i>=0;i--){
			this.instances[i].resolve(value);
			this.instances.splice(i,1);
		}
	}

	private rejectAll(error:any){
		for (let i = this.instances.length-1; i>=0;i--){
			this.instances[i].reject(error);
			this.instances.splice(i,1);
		}
	}
}